import { useConfig } from '@nexelem/config';
import { useAuthContext } from '../../../../../providers/AuthProvider';
import { PERMS } from '../../../../../routes/permissions';

export const useDisableKanbanDnd = () => {
  const { clientId } = useConfig();
  const { hasPermission } = useAuthContext();
  const canEditPlan = hasPermission(PERMS.PERM_4);

  return clientId !== 'sanok' || !canEditPlan;
};
